import { makeAsyncActionCreators } from '../../helpers';
import { ClaudeActionTypes } from '../types';

const askClaude = makeAsyncActionCreators(
  ClaudeActionTypes.askClaude,
  ['message', 'projectId', 'isTranscriptIncluded', 'tokensMultiplier'],
  ['answer'],
  ['error'],
);

const wrapWithTagsAndSave = makeAsyncActionCreators(
  ClaudeActionTypes.wrapWithTagsAndSave,
  ['message', 'projectId', 'callback'],
  ['answer', 'chapters'],
  ['error'],
);

const generateClaudeReplyWithTranscript = makeAsyncActionCreators(
  ClaudeActionTypes.generateClaudeReplyWithTranscript,
  ['message', 'projectId', 'callback'],
  [],
  ['error'],
);

export default {
  askClaude,
  wrapWithTagsAndSave,
  generateClaudeReplyWithTranscript,
};
